import * as React from 'react';
import * as _ from 'underscore';

import { connect } from 'react-redux';
import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { IAdminSiteStatusScope } from '../../../ts/controllers/AdminSiteStatusCtrl';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { AngularContext } from '../../../ts/factories/AngularContextFactory';
import { SessionServerSelectors } from '../../selectors/SessionInfoSelectors';
import { AppState } from '../../state/AppState';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { RouterError } from '../RouterHelpers/RouterError';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export interface SiteStatusSpaceProviderOwnProps extends ReactDirectiveProps {
  readonly angularContext: AngularContext;
  readonly urls: SpacesSiteUrls;
}

export interface SiteStatusSpaceProviderStateProps {
  readonly isAdminViewsEnabled: boolean;
}

export type SiteStatusSpaceProviderComponentProps = SiteStatusSpaceProviderOwnProps & SiteStatusSpaceProviderStateProps;

const template = `<div ng-controller="AdminSiteStatusCtrl" ng-include="'siteStatus.html'"></div>`;

export class SiteStatusSpaceProviderComponent extends React.PureComponent<SiteStatusSpaceProviderComponentProps> {

  public render() {
    if (this.props.isAdminViewsEnabled) {
      return this.renderSubSpace();
    } else {
      return <RouterError errorType={'default'} urls={this.props.urls} />;
    }
  }

  private renderSubSpace = () => {
    // the parent div here is important to ensure AngularDirective plays nice when unmounting
    return (
      <div>
        <AngularDirective
          template={template}
          angularContext={this.props.angularContext}
          setupScope={this.setupScope}
        />
      </div>
    );
  }

  private setupScope = (scope: ng.IScope) => {
    const childScope = scope.$new() as IAdminSiteStatusScope;
    return childScope;
  }
}

const mapStateToProps: MapStateToProps<SiteStatusSpaceProviderStateProps> = (appState: AppState) => ({
  isAdminViewsEnabled: SessionServerSelectors.isAdminViewsEnabled(appState)
});

export const ConnectedSiteStatusSpaceProviderComponent: React.ComponentClass<SiteStatusSpaceProviderOwnProps>
  = connect(mapStateToProps, undefined)(SiteStatusSpaceProviderComponent);

export type SiteStatusSpaceProviderProps = SiteStatusSpaceProviderOwnProps;

const SiteStatusSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'sitestatus',
  subspaceName: undefined
};

export function SiteStatusSpaceProvider(props: SiteStatusSpaceProviderProps) {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={SiteStatusSpaceInfo}>
      <ConnectedSiteStatusSpaceProviderComponent {...props} />
    </ConnectedSpaceInfoProvider>
  );
}
